module.exports = __webpack_public_path__ + "2c5ae1fc8485eb5242f768d71aa2e607.jpg";